import { Icon } from "@rmwc/icon"
import "@rmwc/icon/styles"

const IconComponent = <Icon icon="thumb_up" />

export const ThumbUpIcon = IconComponent
